import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { ListMusic, ChevronRight, Tv } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const playlistColors = ['#FF3860', '#4AC6FF', '#FFDE00', '#39FF14', '#FF6B00'];

export default function PlaylistsPage() {
  const [playlists, setPlaylists] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/playlists`).then(r => { setPlaylists(r.data); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  return (
    <div className="page-content">
      <div className="max-w-7xl mx-auto px-6 md:px-8 lg:px-12 py-8">
        <div className="flex items-center gap-3 mb-2">
          <ListMusic size={28} strokeWidth={2.5} className="text-[#FF3860]" />
          <h1 className="font-['Fredoka'] text-4xl sm:text-5xl font-black text-[#0A0A0A] tracking-tight" data-testid="playlists-title">
            Themed Playlists
          </h1>
        </div>
        <p className="text-base text-[#4B5563] font-['Nunito'] mb-8">Handpicked collections of classic shows for every mood and moment</p>

        {loading ? (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {[...Array(4)].map((_, i) => (
              <div key={i} className="neo-card animate-pulse p-6"><div className="h-6 bg-gray-200 rounded w-1/2 mb-3" /><div className="h-4 bg-gray-200 rounded w-3/4" /></div>
            ))}
          </div>
        ) : playlists.length === 0 ? (
          <div className="text-center py-20" data-testid="no-playlists">
            <Tv size={48} className="text-[#4B5563] mx-auto mb-4" strokeWidth={1.5} />
            <p className="font-['Fredoka'] text-2xl text-[#4B5563]">No playlists yet</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 stagger-children">
            {playlists.map((pl, i) => (
              <Link
                key={pl.id}
                to={`/playlists/${pl.slug}`}
                className="neo-card overflow-hidden group animate-fade-in-up"
                style={{ opacity: 0 }}
                data-testid={`playlist-card-${pl.slug}`}
              >
                <div className="flex">
                  <div className="w-32 h-32 shrink-0 border-r-2 border-[#0A0A0A] overflow-hidden">
                    <img
                      src={pl.image_url || `https://img.youtube.com/vi/dQw4w9WgXcQ/hqdefault.jpg`}
                      alt={pl.title}
                      className="w-full h-full object-cover vhs-thumbnail group-hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                  <div className="flex-1 p-5 flex flex-col justify-between" style={{ backgroundColor: playlistColors[i % playlistColors.length] + '10' }}>
                    <div>
                      <h3 className="font-['Fredoka'] font-bold text-xl text-[#0A0A0A] mb-1 group-hover:text-[#FF3860] transition-colors">
                        {pl.title}
                      </h3>
                      <p className="text-sm text-[#4B5563] font-['Nunito'] line-clamp-2">{pl.description}</p>
                    </div>
                    <div className="flex items-center justify-between mt-3">
                      <span className="text-xs font-bold text-[#4B5563] font-['IBM_Plex_Mono']">{pl.show_count} shows</span>
                      <ChevronRight size={16} strokeWidth={2.5} className="text-[#4B5563] group-hover:text-[#FF3860] transition-colors" />
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
